import {
    getData,
    postData,
    deleteData
} from './Services'

export const getArtTallesPanel = async (artId,searchTerm, page, perPage) => {
    let queryParams = [];
    if (artId) {
        queryParams.push(`art_Id=${encodeURIComponent(artId || '')}`);
    }
    if (searchTerm) {
        queryParams.push(`tal_descripcion=${encodeURIComponent(searchTerm || '')}`);
    }
    if (page) {
        queryParams.push(`page=${encodeURIComponent(page || 1)}`);
    }
    if (perPage) {
        queryParams.push(`perPage=${encodeURIComponent(perPage || 10)}`);
    }
    const queryString = queryParams.length > 0 ? `?&${queryParams.join('&')}` : '';

    return await getData("/articulostalles", queryString);
};

export const getArtTalleById = async (id) => {
    const res = await getData(`/articulostalles/${id}`)
    return res
}

export const postArtTalle = async (body) => {
    const res = await postData('/articulostalles', body)
    return res
}

export const deleteArtTalle = async (id) => {
    const res = await deleteData(`/articulostalles/${id}`)
    return res
}